/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';

import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import { isWeb } from '@global/screens';
import { showPopup } from '@/store/modal';

import HamburgerButton from '@components/navbar/HamburgerButton';
import BackButton from '@components/navbar/BackButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import MoreButton from '@components/navbar/MoreButton';

import ProfileScreen from '@/screens/setting/profile/ProfileScreen';

import { MsAccount } from '@api/ms-account';

const Stack = createStackNavigator();

const ProfileNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  const goToProfileForm = (props, params = {}) => {
    props.navigation.navigate('UserNavigator', {
      screen: 'UserFormScreen',
      params: params,
    });
  };

  return (
    <Stack.Navigator
      initialRouteName="ProfileScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="ProfileScreen"
        component={ProfileScreen}
        options={(props) => {
          const route = props.route;
          let isDetail = false;
          let title = 'My Profile';
          let backParams = {};

          if (route.params) {
            if (route.params.titleScreen) {
              title = route.params.titleScreen;
              isDetail = true;
            }
            if (isDetail) {
              if (route.params.branchName) {
                backParams = {
                  screen: 'BranchListNavigator',
                  params: {
                    screen: 'BranchListDetailScreen',
                    params: {
                      ...route.params,
                      id: route.params.branchId,
                      titleScreen: route.params.branchName,
                      name: route.params.branchName,
                    },
                  },
                };
              } else {
                backParams = {
                  screen: 'UserNavigator',
                  params: {
                    screen: 'UsersScreen',
                    params: route.params,
                  },
                };
              }
            }
          }

          return {
            title: setTitleHeader(title),
            headerLeft: () =>
              isDetail && backParams && Object.keys(backParams).length ? (
                <BackButton
                  {...props}
                  customBack={backParams}
                  isJump={isDetail}
                />
              ) : (
                <HamburgerButton {...props} />
              ),
            headerRight: () => {
              const onInvite = async () => {
                if (route && route.params && route.params.id) {
                  dispatch(showPopup({ name: 'isLoading', value: true }));
                  const inviteUser = await MsAccount.inviteUser(
                    route.params.id,
                  );
                  if (inviteUser && inviteUser.data && inviteUser.data.data) {
                    dispatch(showPopup({ name: 'isLoading', value: false }));
                    Toast.show({
                      text1: 'Successfully invited user',
                      type: 'success',
                    });
                  } else {
                    dispatch(showPopup({ name: 'isLoading', value: false }));
                    Toast.show({
                      text1: 'Failed to invite user',
                      type: 'error',
                    });
                  }
                } else {
                  Toast.show({
                    text1: 'A system error occurred',
                    type: 'error',
                  });
                }
              };
              return isWeb ? (
                <NotificationSettingButton {...props} />
              ) : isDetail ? (
                <MoreButton
                  menu={[
                    {
                      type: 'function',
                      name: 'Edit',
                      callback: () => goToProfileForm(props, route.params),
                    },
                    {
                      type: 'function',
                      name: 'Invite User',
                      callback: onInvite,
                    },
                  ]}
                  {...props}
                />
              ) : (
                false
              );
            },
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default ProfileNavigator;
